import { useCallback, useEffect } from "react";

export function useKeyPress(
  targetKey: string,
  callback: () => void,
  requiresModifiers: boolean = false,
) {
  const downHandler = useCallback(
    ({ key, metaKey, ctrlKey }: KeyboardEvent) => {
      if (key === targetKey) {
        // if modifier keys are required and cmd or ctrl are not pressed then exit early
        if (requiresModifiers && !(metaKey || ctrlKey)) {
          return;
        }

        callback();
      }
    },
    [targetKey, callback, requiresModifiers],
  );

  useEffect(() => {
    window.addEventListener("keydown", downHandler);
    return () => {
      window.removeEventListener("keydown", downHandler);
    };
  }, [downHandler]);
}
